// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","toolbar":"toolbar-tq2rq","inner":"inner-1GIZ2","actions":"actions-3yTt-"};